import Vuex from "vuex";

window.store = new Vuex.Store({
  state: {
    saving: 0,
    feedback: false,
    isNavigationOpen: false,
    language: localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en",
    user: false
  },
  mutations: {
    toggleNavigation(state) {
      state.isNavigationOpen = !state.isNavigationOpen;
    },
    addSavingProcess(state) {
      state.saving = state.saving + 1;
    },
    finishSavingProcess(state) {
      state.saving = state.saving - 1;
    },
    login(state, user) {
      state.user = user;
    },
    logout(state) {
      state.user = false;
    }
  },
  actions: {
    login(store) {
      console.log(currentUserUrl)
      axios.get(currentUserUrl).then(({ data }) => {
        store.commit("login", data.result);
      });
    }
  }
});
export default window.store;



// WEBPACK FOOTER //
// ./src/stores/admin.js